// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__6c0TL","text":"styles_text__Re-Gl"};